import WundWWizard from './WundWWizard';

export default WundWWizard;
